import styled from 'styled-components';
import { palette } from 'styled-tools';

import { expandTapTarget, IconButton, minWidth } from '@calm-web/design-system';

import GridWrapper from '@/components/ui/GridWrapper';

export const Grid = styled(GridWrapper)`
	padding-top: 8px;
	position: relative;

	${minWidth('tablet')} {
		grid-template-columns: 1fr 2fr 2fr 1fr;
		padding-top: 48px;
	}
`;

export const Wrapper = styled.div<{ isVisible: boolean }>`
	align-items: center;
	display: flex;
	flex-direction: column;
	height: 100%;
	grid-column-end: 4;
	grid-column-start: 1;
	text-align: center;
	width: 100%;

	${minWidth('tablet')} {
		grid-column-start: 2;
	}
`;

export const BackButton = styled(IconButton)<{ $rotate?: boolean }>`
	cursor: pointer;
	height: 24px;
	left: 0;
	position: absolute;
	top: 0;
	transform: ${p => (p.$rotate ? 'rotate(0deg)' : 'rotate(-90deg)')};
	width: 24px;

	& path {
		fill: ${palette('white')};
	}

	/* This button's containing block (GridWrapper's Grid) sits inside an
	 * ancestor with overflow: hidden and no top slack, so a tap-target inset
	 * on the screen-top side is clipped away rather than expanding the hit
	 * area (confirmed on a real device and in a browser repro). Because this
	 * element itself carries a 90deg rotation, a CSS inset direction isn't the
	 * same as its on-screen direction: rotate(-90deg) (the default) puts the
	 * clipped side on CSS "right", not CSS "top". Each branch below zeroes
	 * whichever CSS side lands on screen-top for that rotation and puts the
	 * full compensation on the opposite side, so the tappable area still
	 * reaches 44x44 without painting into the clipped region. */
	${p =>
		p.$rotate
			? expandTapTarget({ top: 0, right: 10, bottom: 20, left: 10 })
			: expandTapTarget({ top: 10, right: 0, bottom: 10, left: 20 })}

	${minWidth('tablet')} {
		height: 32px;
		width: 32px;

		${p =>
			p.$rotate
				? expandTapTarget({ top: 0, right: 6, bottom: 12, left: 6 })
				: expandTapTarget({ top: 6, right: 0, bottom: 6, left: 12 })}
	}
`;
